<template>
    <b-modal id="modal-kirim-dus" size="lg" :title="`Kirim ${dusWord}`" centered no-close-on-backdrop no-close-on-esc hide-footer @show="onShow" @hidden="resetForm">

        <div class="detail-data-wrapper mb-3">
            <h6 class="form-title mb-2">{{ dusWord }} yang akan dikirim ({{ pendingDuses.length }})</h6>
            <div class="d-flex flex-wrap">
                <b-badge variant="primary" class="mr-2 mb-2" v-for="item in pendingDusSummary" :key="item.label">{{ item.label }} ({{ item.count }})</b-badge>
            </div>
        </div>

        <div class="detail-data-wrapper mb-3" v-if="kirimInfo">
            <h6 class="form-title mb-2">Informasi Pengiriman</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Titik Drop Off</b-col>
                <b-col>
                    <b-badge :variant="kirimInfo.isDropOffToOwnCabang ? 'info' : 'warning'">{{ kirimInfo.isDropOffToOwnCabang ? 'Cabang Sendiri' : 'Titip Cabang Lain' }}</b-badge>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Cabang Tujuan</b-col>
                <b-col>
                    <strong>{{ kirimInfo.dropOffDestinationCabangName || '-' }}</strong>
                    <div class="smallText text-muted">
                        <i class="fa fa-map-marker mr-1"></i>{{ kirimInfo.dropOffDestinationCabangAlamat || 'Alamat belum tersedia' }}
                    </div>
                    <b-button v-if="dropOffMapsUrl" :href="dropOffMapsUrl" target="_blank" rel="noopener noreferrer" size="sm" variant="outline-primary" class="text-nowrap mt-2">
                        <i class="fa fa-external-link mr-1"></i>Buka Maps
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tujuan SM</b-col>
                <b-col>{{ kirimInfo.smDestinationName || '-' }}</b-col>
            </b-row>
            <b-row>
                <b-col cols="4" class="detail-data-label">Metode Pengiriman</b-col>
                <b-col>{{ kirimInfo.deliveryChannelName || '-' }}</b-col>
            </b-row>
        </div>

        <b-form-checkbox v-if="isDitolakDropoff" v-model="useFotoSebelumnya" class="mb-2" name="useFotoSebelumnya">
            Gunakan foto/video sebelumnya
        </b-form-checkbox>

        <div class="mb-3" v-if="useFotoSebelumnya">
            <ModalFotoPengiriman buttonLabel="Lihat Foto/Video Sebelumnya" title="Foto/Video Sebelumnya" :groups="shipmentPhotoGroups" />
        </div>

        <div class="form-content-wrapper" v-if="!useFotoSebelumnya">
            <div v-if="isLoadingPhotoCategories" class="text-center py-3">
                <b-spinner small class="mr-2" />Memuat kategori foto/video...
            </div>
            <template v-else-if="photoCategories.length > 0">
                <b-form-group label="Kategori Foto/Video" class="mb-2">
                    <multiselect
                        class="mw-100"
                        name="kategoriFotoDus"
                        :value="photoCategories.find(category => category.id == activeCategoryId) || null"
                        :options="photoCategories"
                        :allow-empty="false"
                        :searchable="false"
                        deselect-label=""
                        select-label=""
                        selected-label=""
                        label="name"
                        track-by="id"
                        @input="activeCategoryId = $event ? $event.id : null"
                    >
                        <template v-slot:singleLabel="{ option }">
                            <span class="d-flex align-items-center justify-content-between" style="gap: 8px;">
                                <span>{{ option.name }}</span>
                                <b-badge :variant="categoryStatus(option).variant">{{ categoryStatus(option).text }}</b-badge>
                            </span>
                        </template>
                        <template v-slot:option="{ option }">
                            <span class="d-flex align-items-center justify-content-between" style="gap: 8px;">
                                <span class="text-wrap">{{ option.name }}</span>
                                <b-badge :variant="categoryStatus(option).variant">{{ categoryStatus(option).text }}</b-badge>
                            </span>
                        </template>
                    </multiselect>
                </b-form-group>
                <p class="smallText mb-3" :class="missingRequiredCategories.length > 0 ? 'text-danger' : 'text-success'">
                    {{ requiredCategories.length - missingRequiredCategories.length }} dari {{ requiredCategories.length }} kategori wajib sudah terisi
                </p>
                <b-button variant="pgiBtn" size="sm" class="mb-2" name="fotoDusAddItemBtn" @click="addFotoDus(activeCategoryId)">
                    <i class="fa fa-plus mr-1"></i>Tambah {{ mediaWord(activeCategoryId) }}
                </b-button>
                <div v-if="activeCategoryFotos.length == 0" class="text-muted text-center py-3">
                    Belum ada {{ mediaWord(activeCategoryId).toLowerCase() }}.
                </div>
                <FotoPendukung
                    v-for="(item, itemIndex) in activeCategoryFotos" v-bind:key="item.index"
                    :fotoPendukung="item"
                    :label="`${mediaWord(item.categoryId)} ${itemIndex + 1}`"
                    :length="activeCategoryFotos.length"
                    :minLength="minPerCategory(activeCategoryId)"
                    :lat="lat"
                    :long="long"
                    :isRemove="activeCategoryFotos.length > minPerCategory(activeCategoryId)"
                    :videoOnly="isVideoCategory(item.categoryId)"
                    @remove="removeFotoDus"
                    @showModalCam="openModalCam"
                    @showModalPreview="openModalPreview"
                />
            </template>
        </div>

        <div class="form-wrapper-btn text-right">
            <b-button variant="pgiBtn" name="kirimDusSubmitBtn" :disabled="!canSubmit" @click="openConfirm">
                <i class="fa fa-send mr-2"></i>
                Kirim
            </b-button>
        </div>

        <ModalConfirm id="modal-confirm-kirim-dus" :title="`Confirm Kirim ${dusWord}`" :isSubmitting="isSubmitting" :desc="`Apakah anda yakin untuk mengirim semua ${dusWord.toLowerCase()}? Status seluruh barang di dalamnya akan berubah jadi Pengiriman.`" @submit="onSubmitKirim" />
        <ModalWebCam idWebcam="webcam-kirim-dus" @photoTaken="setResult" />
        <ModalPreview modalId="modal-preview-kirim-dus" :fotoPreview="activeFotoPreview" :isVideo="activeFotoPreviewIsVideo" />
    </b-modal>
</template>

<script>
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'
import ModalFotoPengiriman from './ModalFotoPengiriman'
import CONSTANTS from '@/constants'

const MAX_VIDEO_SIZE = 200 * 1024 * 1024
const MAX_VIDEO_PER_CATEGORY = 3
const MAX_FOTO_PER_CATEGORY = 6

export default {
    name: 'modal-kirim-dus',
    components: {
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        ModalFotoPengiriman,
    },
    props: {
        id: { type: [String, Number], required: true },
        dusWord: { type: String, default: 'Dus' },
        pendingDuses: { type: Array, required: true },
        kirimInfo: { type: Object, default: null },
        shipmentStatus: { type: Number, default: null },
        shipmentPhotoGroups: { type: Array, default: () => [] },
        jenisPinjamanId: { type: Number, default: null },
    },
    data() {
        return {
            useFotoSebelumnya: false,

            fotoDus: [],
            indexFotoDus: 0,
            photoCategories: [],
            activeCategoryId: null,
            isLoadingPhotoCategories: false,
            activeFotoDusIndex: null,
            activeFotoPreview: '',
            activeFotoPreviewIsVideo: false,
            lat: 0,
            long: 0,

            isSubmitting: false,
        }
    },
    computed: {
        isDitolakDropoff() {
            return this.shipmentStatus == CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.DITOLAK_DROPOFF
        },
        pendingDusSummary() {
            const counts = {}
            this.pendingDuses.forEach(dus => {
                counts[dus.dusType] = (counts[dus.dusType] || 0) + 1
            })
            return Object.keys(counts).map(dusType => ({
                label: dusType,
                count: counts[dusType],
            }))
        },
        requiredCategories() {
            return this.photoCategories.filter(category => this.isRequiredCategory(category))
        },
        activeCategoryFotos() {
            return this.fotoDus.filter(item => item.categoryId == this.activeCategoryId)
        },
        dropOffMapsUrl() {
            const url = this.kirimInfo && this.kirimInfo.dropOffDestinationCabangLinkMaps
            return url && /^https?:\/\//i.test(url) ? url : null
        },
        hasLuarDus() {
            return this.pendingDuses.some(dus => dus.dusNumber == 'LD')
        },
        missingRequiredCategories() {
            return this.photoCategories.filter(category => this.isRequiredCategory(category) && !this.fotoDus.some(item => item.categoryId == category.id && item.activeFotoPendukungBase64))
        },
        canSubmit() {
            return this.pendingDuses.length > 0
        },
    },
    methods: {
        onShow() {
            this.resetForm()
            if (this.photoCategories.length > 0) return

            this.isLoadingPhotoCategories = true
            this.$axios.get('lelang-packing/photo-categories', { params: { jenisPinjamanId: this.jenisPinjamanId } }).then(response => {
                this.photoCategories = response.data || []
                this.resetForm()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingPhotoCategories = false
            })
        },

        categoryStatus(category) {
            const filled = this.fotoDus.filter(item => item.categoryId == category.id && item.activeFotoPendukungBase64).length
            if (filled > 0) return { variant: 'success', text: `✓ ${filled} ${this.mediaWord(category.id).toLowerCase()}` }
            if (this.isRequiredCategory(category)) return { variant: 'danger', text: 'Wajib' }
            return { variant: 'secondary', text: 'Opsional' }
        },

        isRequiredCategory(category) {
            if (this.hasLuarDus && (category.name || '').toLowerCase().includes('luar dus')) return true
            return Boolean(category.mediaRequirement && category.mediaRequirement.required)
        },

        isVideoCategory(categoryId) {
            const category = this.photoCategories.find(category => category.id == categoryId)
            return Boolean(category && category.mediaRequirement && category.mediaRequirement.type == 'VIDEO')
        },

        mediaWord(categoryId) {
            return this.isVideoCategory(categoryId) ? 'Video' : 'Foto'
        },

        categoryName(categoryId) {
            const category = this.photoCategories.find(category => category.id == categoryId)
            return category ? category.name : ''
        },

        makeFotoDus(categoryId) {
            return {
                id: 0,
                index: this.indexFotoDus++,
                categoryId,
                checkFotoBarangPendukung: false,
                fotoBarangPendukungPlaceholder: `Pilih ${this.mediaWord(categoryId).toLowerCase()}`,
                fotoBarangPendukung: null,
                fotoBarangPendukungBase64: null,
                activeFotoPendukungBase64: null,
                publicUrl: null,
                isUploading: false,
                isVideo: false,
            }
        },

        maxPerCategory(categoryId) {
            return this.isVideoCategory(categoryId) ? MAX_VIDEO_PER_CATEGORY : MAX_FOTO_PER_CATEGORY
        },

        minPerCategory(categoryId) {
            const category = this.photoCategories.find(category => category.id == categoryId)
            return category && this.isRequiredCategory(category) ? 1 : 0
        },

        addFotoDus(categoryId) {
            const max = this.maxPerCategory(categoryId)
            if (this.fotoDus.filter(item => item.categoryId == categoryId).length >= max) {
                this.$helper.toastErr(this, `${this.categoryName(categoryId)} sudah mencapai maksimal ${max} ${this.mediaWord(categoryId).toLowerCase()}!`)
                return
            }

            this.fotoDus.push(this.makeFotoDus(categoryId))
        },

        revokeBlob(url) {
            if (url && url.startsWith('blob:')) URL.revokeObjectURL(url)
        },

        removeFotoDus(index) {
            const removed = this.fotoDus.find(item => item.index == index)
            if (removed) this.revokeBlob(removed.activeFotoPendukungBase64)
            this.fotoDus = this.fotoDus.filter(item => item.index != index)
        },

        openModalCam(index) {
            this.activeFotoDusIndex = index
            this.$bvModal.show('webcam-kirim-dus')
        },

        openModalPreview(index) {
            let idx = this.fotoDus.findIndex(item => item.index == index)
            this.activeFotoPreview = this.fotoDus[idx].activeFotoPendukungBase64
            this.activeFotoPreviewIsVideo = this.fotoDus[idx].isVideo
            this.$bvModal.show('modal-preview-kirim-dus')
        },

        async setResult(result) {
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()

            var newResult = await this.$helper.resizeImage(result)

            let img = new Image()
            img.src = newResult
            img.onload = () => {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                canvas.setAttribute('width', img.width)
                canvas.setAttribute('height', img.height)

                ctx.drawImage(img, 0, 0)
                ctx.font = '14pt Arial'
                ctx.fillStyle = '#ffffff'
                ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.fillText(this.lat + ' ' + this.long, 10, img.height - 10)
                ctx.strokeText(this.lat + ' ' + this.long, 10, img.height - 10)

                let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                let idx = this.fotoDus.findIndex(item => item.index == this.activeFotoDusIndex)
                this.revokeBlob(this.fotoDus[idx].activeFotoPendukungBase64)
                this.fotoDus[idx].isVideo = false
                this.fotoDus[idx].fotoBarangPendukungBase64 = newBase64Str
                this.fotoDus[idx].activeFotoPendukungBase64 = newBase64Str
                this.fotoDus[idx].fotoBarangPendukungPlaceholder = 'Foto dari Kamera'
                this.fotoDus[idx].checkFotoBarangPendukung = true
            }

            this.$bvModal.hide('webcam-kirim-dus')
        },

        openConfirm() {
            if (!this.useFotoSebelumnya) {
                if (this.missingRequiredCategories.length > 0) {
                    return this.$helper.toastErr(this, `Mohon lengkapi foto/video wajib: ${this.missingRequiredCategories.map(category => category.name).join(', ')}`)
                }
                const emptyCategories = this.photoCategories.filter(category => this.fotoDus.some(item => item.categoryId == category.id && !item.activeFotoPendukungBase64))
                if (emptyCategories.length > 0) {
                    return this.$helper.toastErr(this, `Masih ada foto/video yang belum diisi di ${emptyCategories.map(category => category.name).join(', ')}. Silakan isi atau hapus terlebih dahulu.`)
                }
                if (!this.fotoDus.some(item => item.activeFotoPendukungBase64)) {
                    return this.$helper.toastErr(this, `Mohon tambahkan foto/video ${this.dusWord.toLowerCase()}!`)
                }
                if (this.fotoDus.some(item => item.isUploading)) {
                    return this.$helper.toastErr(this, "Masih ada foto/video yang sedang diupload, mohon tunggu.")
                }
                if (this.fotoDus.some(item => item.activeFotoPendukungBase64 && !item.publicUrl)) {
                    return this.$helper.toastErr(this, `Masih ada foto/video ${this.dusWord.toLowerCase()} yang belum diupload!`)
                }
            }

            if (!this.canSubmit) return
            this.$bvModal.show('modal-confirm-kirim-dus')
        },

        isValidFotoType(file, isVideoCategory) {
            if (!file) return !isVideoCategory

            const type = (file.type || '').toLowerCase()
            const name = (file.name || '').toLowerCase()

            if (isVideoCategory) return type.startsWith('video/')
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(type)
                || name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.png')
        },

        async uploadFotoDus(item) {
            if (item.isUploading || item.publicUrl) return

            const isVideoCategory = this.isVideoCategory(item.categoryId)
            const invalidMessage = !this.isValidFotoType(item.fotoBarangPendukung, isVideoCategory)
                ? `${this.categoryName(item.categoryId)} hanya menerima ${isVideoCategory ? 'video' : 'foto JPG, JPEG, atau PNG'}!`
                : item.isVideo && item.fotoBarangPendukung.size > MAX_VIDEO_SIZE
                    ? "Ukuran video maksimal 200MB!"
                    : null
            if (invalidMessage) {
                this.$helper.toastErr(this, invalidMessage)
                this.revokeBlob(item.activeFotoPendukungBase64)
                item.fotoBarangPendukung = null
                item.fotoBarangPendukungBase64 = null
                item.activeFotoPendukungBase64 = null
                item.checkFotoBarangPendukung = false
                item.isVideo = false
                return
            }

            item.isUploading = true
            this.$store.dispatch("loading/show", { progress: 0 })
            try {
                const fileUpload = item.isVideo
                    ? item.fotoBarangPendukung
                    : await (await fetch(item.activeFotoPendukungBase64)).blob()

                const response = await this.$helper.uploadPresigned({
                    vue: this,
                    path: `lelang-packing/${this.id}/shipment/create-presigned-url`,
                    params: { categoryId: item.categoryId, jenisPinjamanId: this.jenisPinjamanId },
                    fileUpload,
                    contentType: item.isVideo ? (item.fotoBarangPendukung.type || 'video/mp4') : 'image/jpeg',
                    onUploadProgress: progress => this.$store.dispatch("loading/setProgress", Math.min(progress, 100)),
                    useXhr: true,
                })

                if (response.success) {
                    item.publicUrl = response.publicUrl
                    if (item.isVideo) {
                        const viewUrl = this.$helper.buildAwsFileUrl(this.$baseFilePathAws, this.getPhotoKey(response.publicUrl))
                        this.revokeBlob(item.activeFotoPendukungBase64)
                        item._uploadedForBase64 = viewUrl
                        item.activeFotoPendukungBase64 = viewUrl
                    } else {
                        item._uploadedForBase64 = item.activeFotoPendukungBase64
                    }
                } else {
                    this.revokeBlob(item.activeFotoPendukungBase64)
                    item.activeFotoPendukungBase64 = null
                }
            } finally {
                item.isUploading = false
                this.$store.dispatch("loading/hide")
            }
        },

        getPhotoKey(publicUrl) {
            return String(publicUrl).replace(/^https?:\/\/[^/]+\//, "")
        },

        onSubmitKirim() {
            this.isSubmitting = true

            const body = {
                useExistingPhotos: this.useFotoSebelumnya,
            }

            if (!this.useFotoSebelumnya) {
                body.photoKeys = this.fotoDus.filter(item => item.publicUrl).map(item => this.getPhotoKey(item.publicUrl))
            }

            this.$axios.post(`lelang-packing/${this.id}/shipment`, body).then(() => {
                this.$bvModal.hide('modal-confirm-kirim-dus')
                this.$bvModal.hide('modal-kirim-dus')

                this.$helper.toastSucc(this, `${this.dusWord} berhasil dikirim!`)
                this.$emit('submitted')
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        resetForm() {
            this.fotoDus.forEach(item => this.revokeBlob(item.activeFotoPendukungBase64))
            this.useFotoSebelumnya = false
            this.indexFotoDus = 0
            this.fotoDus = this.photoCategories.filter(this.isRequiredCategory).map(category => this.makeFotoDus(category.id))
            this.activeCategoryId = this.photoCategories.length > 0 ? this.photoCategories[0].id : null
        },
    },
    watch: {
        // Upload otomatis begitu foto (browse/camera) selesai diproses jadi base64 —
        // dan kalau fotonya diganti setelah pernah ke-upload, re-upload ulang.
        fotoDus: {
            deep: true,
            handler(list) {
                list.forEach(item => {
                    if (item.publicUrl && item._uploadedForBase64 !== item.activeFotoPendukungBase64) {
                        item.publicUrl = null
                    }
                    if (item.activeFotoPendukungBase64 && !item.publicUrl && !item.isUploading) {
                        this.uploadFotoDus(item)
                    }
                })
            },
        },
    },
    beforeDestroy() {
        this.fotoDus.forEach(item => this.revokeBlob(item.activeFotoPendukungBase64))
    },
    created() {
        navigator.geolocation.getCurrentPosition(position => {
            this.lat = position.coords.latitude
            this.long = position.coords.longitude
        })
    },
}
</script>
